module.exports = __webpack_public_path__ + "img/Incubator.74a5ee1c.png";